import { render, staticRenderFns } from "./freightCompensationStatistical.vue?vue&type=template&id=44f8cb33&scoped=true"
import script from "./freightCompensationStatistical.vue?vue&type=script&lang=ts"
export * from "./freightCompensationStatistical.vue?vue&type=script&lang=ts"
import style0 from "./freightCompensationStatistical.vue?vue&type=style&index=0&id=44f8cb33&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f8cb33",
  null
  
)

export default component.exports